import axios from 'axios';

const BASE = '/api/v1/paie/bulletins/espace-salarie';

export interface BulletinResum {
  idBulletin: string;
  mois: number;
  annee: number;
  statut: string;
  salaireBase: number;
  salaireBrut: number;
  salaireNet: number;
  netAPayer: number;
  dateGeneration: string;
}

export interface BulletinDetail {
  idBulletin: string;
  mois: number;
  annee: number;
  statut: string;
  salaireBase: number;
  primes: number;
  indemnites: number;
  salaireBrut: number;
  montantCNSS: number;
  montantCNSSPatronal: number;
  montantITS: number;
  montantVPS: number;
  salaireNet: number;
  avanceAcompte: number;
  oppositions: number;
  taxesTemporaires: number;
  netAPayer: number;
  dateGeneration: string;
  employe: {
    idEmploye: string;
    nom: string;
    prenoms: string;
    fonction: string;
    salaireBase: number;
    numeroCnss?: string;
    ifu?: string;
    npi?: string;
    dateEmbauche: string;
    numeroMatricule?: string;
  };
  lignesCalcul: Array<{
    idLigne: string;
    code: string;
    libelle: string;
    categorie: string;
    base: number;
    taux?: number;
    quantite?: number;
    montant: number;
    ordre: number;
    afficher: boolean;
  }>;
}

export interface ProfilEmploye {
  idEmploye: string;
  nom: string;
  prenoms: string;
  fonction: string;
  salaireBase: number;
  numeroCnss?: string;
  ifu?: string;
  npi?: string;
  lieuTravail?: string;
  telephone?: string;
  numeroMatricule?: string;
  dateEmbauche: string;
  actif: boolean;
}

function extractDonnees<T>(response: any): T {
  if (response?.succes) {
    return (response.donnees ?? response.data) as T;
  }
  return response as T;
}

export const espaceSalarieApi = {
  listerMesBulletins: () =>
    axios.get<any>(`${BASE}/mes-bulletins`).then(r => {
      const d = r.data;
      const donnees = d?.succes ? (d.donnees ?? d.data) : d;
      return (donnees?.bulletins ?? donnees ?? []) as BulletinResum[];
    }),

  obtenirMonBulletin: (id: string) =>
    axios.get<any>(`${BASE}/mes-bulletins/${id}`).then(r => {
      const d = r.data;
      return extractDonnees<BulletinDetail>(d?.succes ? (d.donnees ?? d.data) ?? d : d);
    }),

  obtenirMonProfil: () =>
    axios.get<any>(`${BASE}/mon-profil`).then(r => {
      const d = r.data;
      return extractDonnees<ProfilEmploye>(d?.succes ? (d.donnees ?? d.data) ?? d : d);
    }),
};
